import { lazy } from '@/service/lazy'
import promotora from './promotora'

export default [{
  name: 'Login',
  path: 'login',
  component: lazy('app/auth/login/index'),
  children: [
    ...promotora
  ]
}]



// WEBPACK FOOTER //
// ./src/router/modules/auth/login.js